/**
 * Created by slava on 4/24/17.
 */

const ToolView = cc.Node.extend({
    ctor: function () {
        this._super();

        this.setLocalZOrder(100);
        this._setGlobalZOrder(true);
        this.onResize();
        this.addSpotlight();
        this.addMenu();
        this.updateMenu();
        this.hide(true);

        cleverapps.toolModel.on("change", this.createListener(this.updateMenu.bind(this)));
        cleverapps.toolModel.on("show", this.createListener(this.show.bind(this)));
        cleverapps.toolModel.on("hide", this.createListener(this.hide.bind(this)));
        cleverapps.toolModel.on("hideSpotlight", this.createListener(this.hideSpotlight.bind(this)));
    },

    onResize: function () {
        const styles = cleverapps.styles.ToolMenu;
        this.setContentSize(styles.width, cleverapps.resolution.getSceneSize().height - styles.topOffset);

        this.stopAllActions();
    },

    addSpotlight: function () {
        this.spotlight = new SpotlightView();
        this.spotlight.setAlignment(cleverapps.styles.ToolMenu.spotlight);
        this.addChild(this.spotlight);
    },

    addMenu: function () {
        const styles = cleverapps.styles.ToolMenu.menu;
        const menu = this.menu = new cc.Scale9Sprite(bundles.tool.frames.tool_bg);
        if (connector.info.isMobile) {
            menu.setScale(1.1);
        }
        menu.setAnchorPoint(0, 0.5);
        menu.onResize = function () {
            menu.setAlignment(styles.x, (this.spotlight.y / 2));
        }.bind(this);
        menu.onResize();
        this.addChild(menu);
    },

    updateMenu: function (search) {
        const styles = cleverapps.styles.ToolMenu.menu;
        const menu = this.menu;
        if (menu.list) {
            menu.list.removeFromParent();
        }
        const items = cleverapps.toolModel.listMenuItems().map(this.createMenuItem.bind(this));

        const list = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        cleverapps.UI.onClick(list, () => {
            cleverapps.toolModel.hide();
        }, {
            interactiveScale: false
        });

        cleverapps.UI.wrapWithPadding(list, styles.padding, true);

        const scroll = new cleverapps.UI.ScrollView(list, {
            childrenVisibility: false,
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL
        });

        scroll.setAnchorPoint(0, 0);

        menu.list = scroll;
        menu.addChild(scroll);

        menu.onResize = function () {
            const winSize = cleverapps.resolution.getSceneSize();
            if (connector.info.isMobile) {
                winSize.height /= 1.5;
            }
            scroll.setContentSize(list.width, Math.min(list.height, winSize.height + styles.dHeight));
            menu.setContentSize(scroll.getContentSize());
        };

        menu.onResize();

        scroll.scrollToDefault();

        this.spotlight.onModelChange(search || "");
    },

    getMenuItemText: function (item) {
        let text = item.key;

        if (item.isFlag() && cleverapps.flags.get(item.entry.flag)) {
            text = `^^${text}`;
        }

        let parent = item.parent;
        while (parent && !parent.isRoot()) {
            text = ToolMenuItem.SUB_ITEM + text;
            parent = parent.parent;
        }

        return text;
    },

    createMenuItem: function (item) {
        const itemText = this.getMenuItemText(item);
        let font = cleverapps.styles.FONTS.TOOL_MENU_TEXT;

        if (itemText.indexOf(ToolMenuItem.ACTIVE_ITEM) !== -1) {
            font = cleverapps.styles.FONTS.TOOL_MENU_ACTIVE_TEXT;
        } else if (itemText.indexOf(ToolMenuItem.DONE_ITEM) !== -1) {
            font = cleverapps.styles.FONTS.TOOL_MENU_DONE_TEXT;
        }

        const text = new TextWithIcon(itemText, {
            font,
            icons: {
                "^^": bundles.checkbox.frames.check_mark_png
            }
        });

        if (item.isFlag()) {
            cleverapps.flags.on(`change:${item.entry.flag}`, () => {
                cleverapps.toolModel.refresh();
            }, text);
        }

        cleverapps.UI.onClick(text, () => {
            item.clickHandler();
        });
        cleverapps.UI.applyHover(text);
        text.setAnchorPoint(0, 0.5);
        return text;
    },

    addOpener: function () {
        const opener = this.opener = new cc.Scale9Sprite(bundles.tool.frames.tool_bg);
        opener.setLocalZOrder(99);
        opener._setGlobalZOrder(true);
        const styles = cleverapps.styles.ToolMenu.opener;
        opener.setAnchorPoint(0, 0.5);
        opener.setContentSize2(styles.width, styles.height);
        opener.setOpacity(128);
        opener.setVisible(false);
        opener.isDisplayed = function () {
            return true;
        };
        cleverapps.UI.onClick(opener, () => {
            if (cleverapps.toolModel.isOpened()) {
                cleverapps.toolModel.hide();
            } else {
                cleverapps.toolModel.show();
            }
        });
        cleverapps.UI.applyHover(opener, {
            onMouseOver: function () {
                opener.setVisible(true);
            },
            onMouseOut: function () {
                opener.setVisible(false);
            }
        });
        opener.setPosition(styles.x, cleverapps.resolution.getSceneSize().height / 2);
        this.getParent().addChild(opener);
    },

    show: function (silent) {
        const styles = cleverapps.styles.ToolMenu;

        this.spotlight.show();
        if (!connector.info.isMobile) {
            this.spotlight.setFocus();
        }

        this.setVisible(true);
        this.spotlight.setVisible(true);

        if (silent) {
            this.setAlignment(styles);
            return;
        }

        this.runAction(
            new cc.MoveTo(0.1, this.positionFromAlignment(styles))
        ).setFinalize(() => {
            this.setAlignment(styles);
        });
    },

    hide: function (silent) {
        this.spotlight.setBlur();
        this.spotlight.hide();
        const pos = cc.p(-this.menu.width, 0);

        if (silent) {
            this.setAlignment(pos);
            this.setVisible(false);
            return;
        }

        this.runAction(
            new cc.Sequence(
                new cc.MoveTo(0.1, this.positionFromAlignment(pos)),
                new cc.Hide()
            )
        ).setFinalize(() => {
            this.setAlignment(pos);
        });
    },

    hideSpotlight: function () {
        this.spotlight.setBlur();
        this.spotlight.hide();
        this.spotlight.setVisible(false);
    }
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    TOOL_MENU_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.BLACK,
        size: 1
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TOOL_MENU_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TOOL_MENU_TEXT_STROKE
    },
    TOOL_MENU_ACTIVE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.YELLOW,
        stroke: cleverapps.styles.DECORATORS.TOOL_MENU_TEXT_STROKE
    },
    TOOL_MENU_DONE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.GREEN,
        stroke: cleverapps.styles.DECORATORS.TOOL_MENU_TEXT_STROKE
    }
});

cleverapps.styles.ToolMenu = {
    x: 0,
    y: 0,
    width: 300,
    topOffset: 80,
    menu: {
        x: 0,
        topOffset: 200,
        bottomOffset: 50,
        dHeight: -230,
        margin: -4,
        padding: {
            top: 20,
            right: 20,
            left: 30,
            bottom: 20
        }
    },
    spotlight: [
        {
            x: { align: "left", dx: 10 },
            y: { align: "top", dy: -140 }
        },
        {
            x: { align: "left", dx: 10 },
            y: { align: "top", dy: -20 }
        },
        {
            x: { align: "left", dx: 10 },
            y: { align: "top", dy: -20 }
        }
    ],
    opener: {
        x: -35,
        width: 70,
        height: 400
    }
};
